import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const pdfEditInCm = isFeature('pdf-edit-in-cm');
